module.exports = __webpack_public_path__ + "static/media/mithras.c1543de9.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Latium/mithras.JPG
// module id = 679
// module chunks = 0